<template>
  <section>
    <h5>{{ properties.title }}</h5>
    <div class="financial-details">
      <p :data-qa="`${dataQa}-summary-line`">{{ properties.summaryLine }}</p>
      <loader v-if="isLoading" />
      <div :data-qa="`${dataQa}-summary-rate`" class="price price-incl">
        {{ properties.rateTotal }}
      </div>
      <button
        v-if="properties.infoModalContent"
        :data-qa="`${dataQa}-info-modal`"
        @click="showInfoModal = !showInfoModal"
      >
        <icon icon="info-plain" large />
      </button>
    </div>
    <form-checkbox
      v-if="!hidePdfCheckbox"
      :id="`${dataQa}-show-in-pdf`"
      :title="properties.showInPdfCheckboxLabel"
      :disabled="properties.isReadOnly"
    >
      <input
        :id="`${dataQa}-show-in-pdf`"
        :checked="properties.showInPdf"
        type="checkbox"
        :disabled="properties.isReadOnly || null"
        @change="$emit('showInPdf', $event.target.checked)"
      />
    </form-checkbox>
    <app-button :data-qa="`${dataQa}-open-modal-button`" @click="$emit('showConfigModal', true)">
      {{ properties.openModalButtonLabel }}
    </app-button>

    <modal v-if="showInfoModal" :title="properties.infoModalTitle" @close="showInfoModal = false">
      <div v-html="properties.infoModalContent"></div>
    </modal>
  </section>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'

export default {
  components: {
    Icon,
    AppButton,
    Modal,
    Loader,
    FormCheckbox,
  },
  props: {
    properties: {
      type: Object,
      required: true,
    },
    dataQa: {
      type: String,
      default: null,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    hidePdfCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['showConfigModal', 'showInPdf'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showInfoModal: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.financial-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--color-border);
  border-width: 1px 0;
  padding: 0.5rem;
  margin-bottom: 1rem;

  p {
    flex-basis: 90%;
    margin: 0;
  }

  .loader {
    font-size: 0.5em;
    transform: translateY(0.5em);
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .price {
    padding: 0 0.25rem;
  }
}

.checkbox-item {
  margin-bottom: 1em;
}
</style>
